import { ProductCategory } from '~/shared/constants/products';

const defaultTopsConfig = {
  assets: {
    desktop: 'embroidery_fallback_image_scrubs_d',
    mobile: 'embroidery_fallback_image_scrubs_m',
  },
  styles: {
    left: {
      desktop: {
        top: 'calc(50% - 183px)',
        right: 'calc(50% - 100px)',
      },
      mobile: {
        top: 'calc(50% - 165px)',
        right: 'calc(50% - 94px)',
      },
    },
    right: {
      desktop: {
        top: 'calc(50% - 183px)',
        right: 'calc(50% + 2px)',
      },
      mobile: {
        top: 'calc(50% - 165px)',
        right: 'calc(50% - 4px)',
      },
    },
  },
};

const hoodiesConfig = {
  assets: {
    desktop: 'embroidery_fallback_image_hoodies_d',
    mobile: 'embroidery_fallback_image_hoodies_m',
  },
  categories: [
    ProductCategory.mensHoodie,
    ProductCategory.womensActivewearHoodies,
  ],
  styles: {
    left: {
      desktop: {
        top: 'calc(50% - 65px)',
        right: 'calc(50% - 100px)',
      },
      mobile: {
        top: 'calc(50% - 65px)',
        right: 'calc(50% - 99px)',
      },
    },
    right: {
      desktop: {
        top: 'calc(50% - 65px)',
        right: 'calc(50% + 4px)',
      },
      mobile: {
        top: 'calc(50% - 65px)',
        right: 'calc(50% + 3px)',
      },
    },
  },
};

const longSleevesConfig = {
  assets: {
    desktop: 'embroidery_fallback_image_longsleeves_d',
    mobile: 'embroidery_fallback_image_longsleeves_m',
  },
  categories: [
    ProductCategory.fitFindsLongSleeve,
    ProductCategory.clearanceLongSleeve,
    ProductCategory.mensFashionLongSleeve,
    ProductCategory.mensLongSleeveTee,
    ProductCategory.womensActivewearLongSleeve,
    ProductCategory.womensActivewearBodysuitLongSleeve,
    ProductCategory.womensFashionLongSleeve,
    ProductCategory.mensSweatshirts,
    ProductCategory.womensSweatshirts,
  ],
  styles: {
    left: {
      desktop: {
        top: 'calc(50% - 130px)',
        right: 'calc(50% - 110px)',
      },
      mobile: {
        top: 'calc(50% - 118px)',
        right: 'calc(50% - 100px)',
      },
    },
    right: {
      desktop: {
        top: 'calc(50% - 130px)',
        right: 'calc(50% + 18px)',
      },
      mobile: {
        top: 'calc(50% - 118px)',
        right: 'calc(50% + 8px)',
      },
    },
  },
};

const teesConfig = {
  assets: {
    desktop: 'embroidery_fallback_image_tees_d',
    mobile: 'embroidery_fallback_image_tees_m',
  },
  categories: [
    ProductCategory.mensFashionLSTee,
    ProductCategory.mensFashionSLTee,
    ProductCategory.mensFashionSSTee,
    ProductCategory.mensShortSleeveTee,
    ProductCategory.womensActivewearShortSleeveTees,
    ProductCategory.womensFashionShortSleeveTees,
    ProductCategory.womensFashionLSTee,
    ProductCategory.womensFashionSLTee,
    ProductCategory.womensFashionSSTee,
  ],
  styles: {
    left: {
      desktop: {
        top: 'calc(50% - 140px)',
        right: 'calc(50% - 100px)',
      },
      mobile: {
        top: 'calc(50% - 128px)',
        right: 'calc(50% - 99px)',
      },
    },
    right: {
      desktop: {
        top: 'calc(50% - 140px)',
        right: 'calc(50% + 4px)',
      },
      mobile: {
        top: 'calc(50% - 128px)',
        right: 'calc(50% + 4px)',
      },
    },
  },
};

const topsLocationConfig = {
  assets: {
    // Note: The order of the assets in this list is important.
    // The logic will return the configuration of the first asset
    // that matches the product's categories.
    default: defaultTopsConfig.assets,
    hoodies: hoodiesConfig.assets,
    longSleeves: longSleevesConfig.assets,
    tees: teesConfig.assets,
  },
  categories: {
    hoodies: hoodiesConfig.categories,
    longSleeves: longSleevesConfig.categories,
    tees: teesConfig.categories,
  },
};

export const EmbroideryLocationConfigs = [
  {
    ...topsLocationConfig,
    customizationLocationTemplateId: 1,
    resourceBundle: {
      id: 'site_pdp.embroidery_location_left',
      defaultMessage: 'Left Chest',
    },
    styles: {
      default: defaultTopsConfig.styles.left,
      hoodies: hoodiesConfig.styles.left,
      longSleeves: longSleevesConfig.styles.left,
      tees: teesConfig.styles.left,
    },
  },
  {
    ...topsLocationConfig,
    customizationLocationTemplateId: 2,
    resourceBundle: {
      id: 'site_pdp.embroidery_location_right',
      defaultMessage: 'Right Chest',
    },
    styles: {
      default: defaultTopsConfig.styles.right,
      hoodies: hoodiesConfig.styles.right,
      longSleeves: longSleevesConfig.styles.right,
      tees: teesConfig.styles.right,
    },
  },
  {
    assets: {
      default: {
        desktop: 'embroidery_fallback_image_bottoms_d',
        mobile: 'embroidery_fallback_image_bottoms_m',
      },
    },
    customizationLocationTemplateId: 9,
    resourceBundle: {
      id: 'site_pdp.embroidery_location_left_thigh',
      defaultMessage: 'Left Thigh',
    },
    styles: {
      default: {
        desktop: {
          top: 'calc(50% - 183px)',
          right: 'calc(50% - 93px)',
        },
        mobile: {
          top: 'calc(50% - 184px)',
          right: 'calc(50% - 94px)',
        },
      },
    },
  },
  {
    assets: {
      default: {
        desktop: 'embroidery_fallback_image_bottoms_d',
        mobile: 'embroidery_fallback_image_bottoms_m',
      },
    },
    customizationLocationTemplateId: 10,
    resourceBundle: {
      id: 'site_pdp.embroidery_location_right_thigh',
      defaultMessage: 'Right Thigh',
    },
    styles: {
      default: {
        desktop: {
          top: 'calc(50% - 183px)',
          right: 'calc(50% - 6px)',
        },
        mobile: {
          top: 'calc(50% - 184px)',
          right: 'calc(50% - 4px)',
        },
      },
    },
  },
  {
    assets: {
      default: {
        desktop: 'embroidery_fallback_image_beltbag_d',
        mobile: 'embroidery_fallback_image_beltbag_m',
      },
    },
    customizationLocationTemplateId: 11,
    resourceBundle: {
      id: 'site_pdp.embroidery_location_upper_center',
      defaultMessage: 'Upper Center',
    },
    styles: {
      default: {
        desktop: {
          top: 'calc(50% - 90px)',
          right: 'calc(50% - 48px)',
        },
        mobile: {
          top: 'calc(50% - 84px)',
          right: 'calc(50% - 47px)',
        },
      },
    },
  },
];
